export default (state = [], action) => {
  // console.log("rs", state);
  // console.log("ra", action);

  switch (action.type) {
    case "FETCH_POSTS":
      return action.payload;
    default:
      return state;
  }
};
